import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { jobApplicationBoostOptions } from '../../../../contactsFilters/defaultFilters';

export const useSourcingCampaignStatusFilter = ({ setFilters }) => {
  const formSchema = Yup.object().shape({
    sourcingCampaignStatus: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.mixed(),
      }),
    ),
  });

  const onSubmit = ({ sourcingCampaignStatus }) => {
    // Handle undefined or empty array
    if (!sourcingCampaignStatus || sourcingCampaignStatus.length === 0) {
      setFilters(
        { sourcingCampaignStatus: [] },
        {
          removeFilters: ['sourcingCampaignStatus'],
        },
      );
      return;
    }

    // Extract values from selected options
    // Note: empty string is a valid value meaning "not boosted", so we preserve it
    const values = sourcingCampaignStatus
      .map((option) => option.value)
      .filter((val) => val !== null && val !== undefined);

    setFilters(
      { sourcingCampaignStatus: values },
      {
        removeFilters: values.length === 0 ? ['sourcingCampaignStatus'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
    sourcingCampaignStatusOptions: jobApplicationBoostOptions,
  };
};

useSourcingCampaignStatusFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
